
import { show, updateExpiredAt } from '@/api/stores'
import { Component, Vue } from 'vue-property-decorator'

@Component({})

export default class extends Vue {
  model: Record<string, any> = {}

  params: Record<string, any> = {
    // eslint-disable-next-line
    expired_at: null,
    status: null
  }

  loading = false

  rules = {}

  async created () {
    const { data } = await show(parseInt(this.$route.params.id), { include: 'merchant' })
    this.model = data
    // eslint-disable-next-line
    this.params.expired_at = this.model.expired_at
    this.params.status = parseInt(this.model.status)
  }

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    try {
      await updateExpiredAt(this.model.id, this.params)
      this.$eva.success('Submit the success!')
      // this.$router.push({ name: 'original_dramas' })
    } finally {
      this.loading = false
    }
  }
}
